export const ERROR_CODES = {
  TRY_AFTER_SOME_TIME: 'TRY_AFTER_SOME_TIME',
  USER_ACCOUNT_BLOCKED: 'USER_ACCOUNT_BLOCKED',
  OTP_REQUIRED: 'OTP_REQUIRED',
  MAX_OTP_LIMIT_EXCEEDED: 'MAX_OTP_LIMIT_EXCEEDED',
  MAX_RESEND_REACHED: 'MAX_RESEND_REACHED',
  INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
  CKYC_AADHAAR_POSSESSION_UNAVAILABLE: 'CKYC_AADHAAR_POSSESSION_UNAVAILABLE',
};

export const ERROR_MESSAGES = {
  CKYC_RECORD_NOT_FOUND: 'No CKYC record found for this PAN. Please continue with Aadhaar.',
  // Exact message returned by the backend when CKYC record has no linked Aadhaar
  CKYC_AADHAAR_POSSESSION_UNAVAILABLE: 'We couldn’t find Aadhaar linked to your CKYC record. DigiLocker is the fastest way forward.',
};

export const getErrorMessage = (errorCode) => {
  if (!errorCode) return '';
  return ERROR_MESSAGES[errorCode] || '';
};
